import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["hoursInput", "totalHours", "totalDays", "remainingDays"]
	static values = {
		contractMaxDays: Number,
		contractHoursAlreadyUsed: Number,
	}

	connect() {
		this.recalculate()
	}

	recalculate() {
		const totalHours = this.hoursInputTargets.reduce((sum, input) => {
			const value = parseFloat(input.value)
			return sum + (Number.isFinite(value) ? value : 0)
		}, 0)

		const totalDays = totalHours / 8
		const alreadyUsedDays = (this.contractHoursAlreadyUsedValue || 0) / 8
		const remainingDays = (this.contractMaxDaysValue || 0) - (alreadyUsedDays + totalDays)

		this.totalHoursTarget.textContent = totalHours.toFixed(2)
		this.totalDaysTarget.textContent = totalDays.toFixed(2)
		this.remainingDaysTarget.textContent = remainingDays.toFixed(2)
	}
}
